export interface KRIPenilaianMain {
  ulid: string;
  skala: number;
  kriteria: string;
  bobot: number;
  created_at: string;
  updated_at: string;
  code: string
}

export interface KRIPenilaianDataModel {
  main: {
    data: KRIPenilaianMain[];
    total: number;
  };
}

export enum KRIPenilaianActionType {
  GetKRIPenilaian = "⌘➝Parameter Setting➝Scoring➝GetHasilEvaluasi",
}

export type KRIPenilaianAction = {
  type: KRIPenilaianActionType.GetKRIPenilaian;
  data: {
    data: KRIPenilaianMain[];
    total: number;
  };
};
